import React from "react";
import { Button, Card } from "react-bootstrap";
import AnimationError from "assets/img/animation_error.gif";

const DeviceGagal = () => {
  return (
    <div
      style={{
        backgroundColor: "#FEFCFC",
        display: "grid",
        placeItems: "center",
        height: "100vh",
      }}
    >
      <Card
        style={{
          backgroundColor: "#FEFCFC",
          borderWidth: 0,
          alignItems: "center",
          width: "100%",
          padding: 20,
          borderRadius: 10,
        }}
      >
        <img
          style={{ width: "300px" }}
          src={AnimationError}
          alt="Icon Success"
        />
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 24,
            // paddingTop: "20px",
          }}
        >
          Yahh perangkat kamu gagal direset
        </p>
        <p
          style={{
            textAlign: "center",
            fontWeight: "400",
            fontSize: 18,
          }}
        >
          Coba Lagi Ya
        </p>
      </Card>
    </div>
  );
};

export default DeviceGagal;
